import { DescribeProperty } from '../../common';
import { AnnotationDeleteResponse } from '../../annotations';
import { Model3dDeleteResponse } from '../../models3d';

export class ProjectDeleteResponse {
  @DescribeProperty({ description: 'The number of entries affected', type: 'number' })
  affected: number;

  @DescribeProperty({ description: 'The number of model3d entries affected', type: 'number' })
  models3dEntriesDeleted: Model3dDeleteResponse[];

  @DescribeProperty({ description: 'The number of annotation entries affected', type: 'number' })
  annotationEntriesDeleted: AnnotationDeleteResponse[];
}
